export enum CouponActionTypes {
  API_RESPONSE_SUCCESS = "@@coupons/API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR = "@@coupons/API_RESPONSE_ERROR",

  CREATE_COUPONS = "@@coupons/CREATE_COUPONS",
  GET_COUPONS_REPORT = "@@coupons/GET_COUPONS_REPORT",
  GET_COUPONS = "@@coupons/GET_COUPONS",
  GET_COUPONS_INFLUENCERS = "@@coupons/GET_COUPONS_INFLUENCERS",
  UPDATE_COUPONS = "@@coupons/UPDATE_COUPONS",
  DELETE_COUPONS = "@@coupons/DELETE_COUPONS",
}
